import { useQueryClient } from "@tanstack/react-query";
import { AppType } from "src/types/apps";

// ----------------------------------------------------------------------

export default function useGetAppSelected() {
	const queryClient = useQueryClient();
	const id = queryClient.getQueryData<string>(["apps", "selected"]) ?? "";
	const apps = queryClient.getQueryData<AppType[]>(["apps"]) ?? [];
	return apps.find((i) => i.id === id);
}
